export default __webpack_public_path__ + "static/media/youtube-bw.dd784f96.svg";